const AGE_RESTRICTION = 13;

let TODAYS_DATE = new Date();

// override todays date
export const setToday = (date) => {
  TODAYS_DATE = new Date(date);
};

export const getAge = (birthdate) => {
  const today = TODAYS_DATE;
  const birthDate = new Date(birthdate);
  let age = today.getFullYear() - birthDate.getFullYear();
  const month = today.getMonth() - birthDate.getMonth();
  if (month < 0 || (month === 0 && today.getDate() < birthDate.getDate())) {
    age -= 1;
  }
  return age;
};

export const isAgeValid = (birthdate) => {
  return getAge(birthdate) >= AGE_RESTRICTION;
};

/**
 * @desc get today's date
 * @param {*} delimiter optional default is using '/'
 * @param {*} is2Digit optional, if is2Digit is set to true, it will return two digit year
 */
export const getToday = (delimiter = '/', is2Digit) => {
  const today = new Date();
  let d = today.getDate();
  let m = today.getMonth() + 1; // January is 0!
  let y = `${today.getFullYear()}`; // convert to string: 2018 -> "2018" so that we can use substring to get 2 digit year

  if (d < 10) {
    d = `0${d}`;
  }

  if (m < 10) {
    m = `0${m}`;
  }
  y = is2Digit ? y.substring(2) : y;

  return `${m}${delimiter}${d}${delimiter}${y}`;
};

export const convertTimestamp = (unixTimestamp) => {
  if (!unixTimestamp) return null;
  return new Date(unixTimestamp);
};

export const getDateYearsFromNow = (years = 1) => {
  const yearsFromNow = new Date();
  yearsFromNow.setFullYear(TODAYS_DATE.getFullYear() + years);
  return yearsFromNow;
};

export const getNumberOfDaysForPause = (nextBillingDateTime, pauseDuration) => {
  if (!nextBillingDateTime || !pauseDuration) {
    return -1;
  }

  const billDate = new Date(nextBillingDateTime);
  const billDateWithPause = new Date(nextBillingDateTime);
  billDateWithPause.setMonth(billDateWithPause.getMonth() + pauseDuration);
  const dateDiff = billDateWithPause - billDate;

  // diff is converted from milliseconds to days
  return Math.round(dateDiff / (1000 * 60 * 60 * 24));
};
